import { Button } from "../../../../../../components/Button/Button"
import { useProduct } from "../factory/useProduct"
import usePluginsSpace from "../../../../../../hooks/usePluginSpace"
import { Input } from "../../../../../../components/Input/Input"
import { get } from "http"
import { FilterOptionsDto } from "../type"



export function FilterOptions({ productFilters, handleFilterChange, filterProduct, categories, registeredGroups }:FilterOptionsDto) {

    
    const { pluginSpace } = usePluginsSpace()

    const isWholeSaler = Boolean(pluginSpace?.wholeSaler)

    return (
        <div className='d-flex align-items-center justify-content-start'>
            <div className='d-flex w-50 '>
                <div className='flex-grow-1 align-items-end  justify-content-start me-5'>
                    <span className='align-self-start'>Categorias</span>
                    <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        options={categories}
                        placeholder={'Categoria'}
                        search={true}
                        value={productFilters.classificationId}
                        change={(value: any) => handleFilterChange({ ...productFilters, classificationId: value })}
                    />
                </div>

                <div className='align-items-center me-5 justify-content-between flex-grow-1'>
                    <span className='align-self-start'>Status</span>
                    <Input
                        inputAttr={{
                            type: 'select',
                        }}
                        options={[
                            {
                                value: 1,
                                select: 'Ativo',
                            },
                            {
                                value: 0,
                                select: 'Inativo',
                            },
                            {
                                value: 2,
                                select: 'Ambos',
                            },
                        ]}
                        value={productFilters.status}
                        placeholder={'Status do Produto'}
                        search={true}
                        change={(value: any) => handleFilterChange({ ...productFilters, status: value })}
                    />
                </div>

                {/* Filtro de Grupo, só aparece se isWholeSaler */}
                {isWholeSaler && (
                    <div className='align-items-center me-5 justify-content-between flex-grow-1'>
                        <span className='align-self-start'>Grupo</span>
                        <Input
                            inputAttr={{
                                type: 'multiselect',
                            }}
                            options={
                                (productFilters.filterGroup && productFilters.filterGroup.some((g: any) => g.value === -1))
                                    ? [{ value: -1, select: 'SEM GRUPO' }]
                                    : [
                                        ...registeredGroups.map((g: any) => ({
                                            value: g.id,
                                            select: g.name,
                                        })),
                                        { value: -1, select: 'SEM GRUPO' },
                                    ].filter((opt) => !productFilters.filterGroup || productFilters.filterGroup.length === 0 || opt.value !== -1)
                            }
                            value={productFilters.filterGroup || []}
                            placeholder={'TODOS'}
                            search={true}
                            change={(selected: any[]) => {
                                let newGroup;
                                if (selected.some((g: any) => g.value === -1)) {
                                    newGroup = [{ value: -1, select: 'SEM GRUPO', label: 'SEM GRUPO' }];
                                } else {
                                    newGroup = selected
                                        .filter((g: any) => g.value !== -1)
                                        .map((g: any) => ({
                                            ...g,
                                            label: g.select || g.label,
                                        }));
                                }
                                handleFilterChange({ ...productFilters, filterGroup: newGroup });
                            }}
                        />
                    </div>
                )}
            </div>

            <div
                className='d-flex align-items-end w-50 justify-content-end h-100'
                style={{
                    marginTop: '48px',
                }}
            >
                <Button
                    text='Filtrar'
                    color='primary'
                    iconColor='#FFF'
                    icon='fas fa-filter'
                    size='small'
                    horizontalPadding={6}
                    btnAttr={{
                        type: 'button',
                    }}
                    click={async () => {
                        await filterProduct()
                    }}
                    btnClass='mb-0 fw-bolder'
                />
            </div>
        </div>
    )
}